<template>
  <div
    @mouseover="emit('mouseover')"
    @mouseleave="emit('mouseleave')"
    :class="['card', { selected: isSelected }]"
    v-b-modal="props.claim.worker_id ? 'candidate_profile_' + props.claim.worker_id : ''"
  >
    <div class="texts">
      <span class="name">{{ formatWorkerName(props.claim.worker_name) }}</span>
      <UserRatingDisplay
        v-if="props.claim.internal_rating"
        :color="PaletteColors['brand-primary']"
        :rating="props.claim.internal_rating"
      />
    </div>
    <EmployeeCompanyLogos :company-logos="companyLogos" />
    <CandidateProfileModal v-if="props.claim.worker_id" :claim="props.claim" />
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import EmployeeCompanyLogos from '@/pages/talent-pool/components/EmployeeCompanyLogos.vue';
import UserRatingDisplay from '@/pages/talent-pool/components/UserRatingDisplay.vue';
import CandidateProfileModal from '@/pages/talent-pool/components/CandidateProfileModal.vue';
import { getCompanyLogosFromRoles, formatWorkerName } from '@/pages/talent-pool/utils/profile';
import { PaletteColors } from '@/Theme';

const props = defineProps({
  claim: {
    type: Object,
    required: true,
  },
  selected: Boolean,
  roles: { type: String },
  shift: { type: Object },
  small: Boolean,
});

const emit = defineEmits(['claimSelected', 'mouseover', 'mouseleave']);

const isSelected = computed(() => props.selected);

const companyLogos = computed(() => {
  const logos = getCompanyLogosFromRoles(props.claim?.roles);
  const paddedLogos = [...logos];
  while (paddedLogos.length < 3) {
    paddedLogos.push('');
  }
  return paddedLogos;
});
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  box-shadow: 0px 2px 1px 0px rgba(34, 40, 47, 0.05), 0px 0px 3px 0px rgba(34, 40, 47, 0.1);
  background-color: var(--palette-color-base-white);
  overflow: hidden;
  padding: 1rem;
  border: 1px solid var(--palette-color-default-lighten-90);
  width: 100%;
  height: 83px;
  cursor: pointer;
}

.texts {
  flex: 1;

  .name {
    font-size: 18px;
    font-weight: 500;
  }
}
</style>
